import { render, staticRenderFns } from "./fa.vue?vue&type=template&id=c5a4d5bc&scoped=true&"
import script from "./fa.vue?vue&type=script&lang=js&"
export * from "./fa.vue?vue&type=script&lang=js&"
import style0 from "./fa.vue?vue&type=style&index=0&id=c5a4d5bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a4d5bc",
  null
  
)

export default component.exports